import {Component, Inject, OnInit, Type} from "@angular/core";
import { faCommentLines } from '@fortawesome/pro-light-svg-icons';
import {ModalToolContainerService, WebmateToolConfig} from '../modaltoolcontainer/modaltoolcontainer.service';
import {TOOL_CONTAINER_DATA} from "@webmate-web-core/shared/tools/modaltoolcontainer/modaltoolcontainer.component";
import {WmNotificationService} from "@webmate-web-core/shared/components/notification/wm-notification.service";
import {
    AvailableTopics,
    Topic,
    UserNotification
} from "@webmate-web-core/shared/types/notification";
import {CustomerScope, GlobalScope, NotificationScope, UserId} from "@webmate-web-core/shared/types/ids";
import {DateTime} from "@webmate-web-core/shared/types/base-types";
import {UserService} from "@webmate-web-core/shared/services/user.service";
import {take} from "rxjs/operators";
import {EditorTextChangeEvent} from "primeng/editor";
import {WmAdminService} from "@webmate-web-core/shared/services/wm-admin.service";
import {CustomerInfo} from "@webmate-web-core/shared/types/customer";
import {AutoCompleteCompleteEvent} from "primeng/autocomplete";

export class NotificationEditorToolConfig implements WebmateToolConfig {
    scrollable = true;

    constructor(public toolName: string, public submitCallback: (conf: NotificationData) => void,
                public availableTopics: AvailableTopics, public readonly isWmAdmin: boolean = false, public title: string = '', public text: string = '') {}
}

export interface NotificationData {
    title: string;
    text: string;
    topic: Topic;
    scope: NotificationScope;
}

@Component({
    templateUrl: './notification-editor-tool.component.html',
    styleUrls: ['./notification-editor-tool.component.less']
})
export class NotificationEditorToolComponent implements OnInit {
    faCommentLines = faCommentLines;

    sending = false;

    availableTopics: AvailableTopics;
    availableScopes: Array<string> = ['Global Scope', 'Customer Scope'];

    title: string;
    text: string;
    topic: Topic;
    userId: UserId;

    previewNotification: UserNotification;
    seenDate: DateTime = new Date().toISOString();

    previewShown: boolean = false;

    selectedScope: string = this.availableScopes[0];
    customerList: CustomerInfo[] = [];
    selectedCustomer: CustomerInfo;



    constructor(@Inject(TOOL_CONTAINER_DATA) public data: NotificationEditorToolConfig, private toolService: ModalToolContainerService, private notificationService: WmNotificationService, private userService: UserService, private wmAdminService: WmAdminService) {}

    ngOnInit(): void {
        this.userService.getCurrentUserData().pipe(take(1)).subscribe(user => {
                this.userId =  user.id
                this.title = this.data.title;
                this.text =  this.data.text;
                this.availableTopics = this.data.availableTopics;
                this.topic = this.availableTopics[0].value;
                this.previewNotification = {
                    body: {title: this.title, text: this.text},
                    scope: this.getScope(),
                    creationTime: this.seenDate,
                    id: '00000000-0000-0000-0000-000000000000',
                    topicName: this.topic,
                    creator: this.userId
                };
            }
        );
    }

    submit(): void {
        const callback = () => {
            this.sending = true;
            let scope: NotificationScope = {type: "GlobalScope"} as GlobalScope
            if (this.data.isWmAdmin && this.selectedScope === 'Customer Scope'){
                scope = {type: 'CustomerScope', customerId: this.selectedCustomer.id} as CustomerScope;
            }
            const textData:NotificationData = {title: this.title, text: this.text, topic: this.topic, scope: scope};
            this.data.submitCallback(textData);
            this.toolService.closeLastTool();
        }
        if (this.data.isWmAdmin) {
            this.notificationService.open(
                "This will send a notification to all webmate users across all customers. Do you want to proceed?",
                "Yes, send global notification",
                callback
            );
        } else {
            callback();
        }
    }

    writeTitle(title: string){
        this.title = title;
        this.updateNotification();
    }

    writeText(text: EditorTextChangeEvent){
        this.text = text.htmlValue;
        this.updateNotification();
    }

    updateNotification() {
        this.previewNotification.topicName = this.topic;
        this.previewNotification.body = {title: this.title, text: this.text};
    }

    getScope(): NotificationScope{ //this is only for the display of the avatar in the preview
        if (this.data.isWmAdmin){
            return {type: 'GlobalScope'}
        }
        return {type: 'CustomerScope'}
    }

    togglePreview() {
        this.previewShown = !this.previewShown
    }

    searchCustomer(input: AutoCompleteCompleteEvent) {
        this.wmAdminService.searchCustomer(input.query).subscribe(next => {
            this.customerList = next;
        });
    }
}

